/**
 * Truncates text in the middle with ellipsis
 * Example: "very-long-filename.txt" becomes "very-long...txt"
 * @param text - The text to truncate
 * @param maxLength - Maximum length of the truncated text
 * @returns The truncated text with ellipsis in the middle
 */
export function truncateTextMiddle(text: string, maxLength: number): string {
  if (!text || text.length <= maxLength) {
    return text
  }

  // Calculate how many characters to keep from start and end
  const ellipsisLength = 3 // "..."
  const availableLength = maxLength - ellipsisLength

  // Keep more characters from the end (file extension) than from the start
  const endLength = Math.ceil(availableLength * 0.6) // 60% from end
  const startLength = availableLength - endLength // 40% from start

  const start = text.substring(0, startLength)
  const end = text.substring(text.length - endLength)

  return `${start}...${end}`
}

/**
 * Truncates text at the end with ellipsis (original behavior)
 * @param text - The text to truncate
 * @param maxLength - Maximum length of the truncated text
 * @returns The truncated text with ellipsis at the end
 */
export function truncateTextEnd(text: string, maxLength: number): string {
  if (!text || text.length <= maxLength) {
    return text
  }

  return text.substring(0, maxLength - 3) + '...'
}

/**
 * Truncates text at the beginning with ellipsis
 * @param text - The text to truncate
 * @param maxLength - Maximum length of the truncated text
 * @returns The truncated text with ellipsis at the beginning
 */
export function truncateTextStart(text: string, maxLength: number): string {
  if (!text || text.length <= maxLength) {
    return text
  }

  return '...' + text.substring(text.length - maxLength + 3)
}
